import evento1Principal from "../img/EventosImportantes/PrimeraPiedraCorporativo2026/General.webp";
import PrimeraPiedra from "../img/EventosImportantes/PrimeraPiedraCorporativo2026/PrimeraPiedra.webp";
import PrimeraPiedraColocacion from "../img/EventosImportantes/PrimeraPiedraCorporativo2026/colocacion.webp";

const eventos = [
  {
    id: 1,
    nombre: "Colocación de la primera piedra 2026",
    fecha: "04 de julio de 2026",
    lugar: "La Huerta, Jalisco",
    categoria: "Ceremonia de inicio de obra",
    descripcion:
      "Colocación de la primera piedra para la construcción de nuestro Salón de Usos Múltiples y la ampliación del Corporativo de Caja Solidaria La Huerta.Un proyecto que representa crecimiento, compromiso y visión de futuro para seguir fortaleciendo nuestra institución y brindar un mejor servicio a nuestros socios.",

    imagenPrincipal:evento1Principal,

    fotografias: [
     PrimeraPiedra,
    PrimeraPiedraColocacion ,
    ],
  },

];

export default eventos;